<template>
  <apexcharts
    ref="accelChart"
    height="350px"
    type="line"
    :options="chartOptions"
    :series="series"
  ></apexcharts>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  components: {
    apexcharts: VueApexCharts,
  },
  props: {
    basicAccelGyroData: [],
  },
  data: function () {
    return {
      series: [
        {
          name: "aX",
          data: [],
        },
        {
          name: "aY",
          data: [],
        },
        {
          name: "aZ",
          data: [],
        },
      ],
      chartOptions: {
        chart: {
          type: "line",
          height: 350,
          stacked: true,
          animations: {
            enabled: true,
          },
        },
        colors: ["#008FFB", "#00E396", "#CED4DC"],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
          width: 1,
        },
        // fill: {
        //   type: "gradient",
        //   gradient: {
        //     shadeIntensity: 1,
        //     inverseColors: false,
        //     opacityFrom: 0.5,
        //     opacityTo: 0,
        //     stops: [0, 90, 100],
        //   },
        // },
        legend: {
          position: "top",
          horizontalAlign: "left",
        },
        yaxis: {
          labels: {
            formatter: function (val) {
              return val.toFixed(2);
            },
          },
          title: {
            text: "Accel",
          },
        },
        xaxis: {
          type: "datetime",
          title: {
            text: "Time",
          },
        },
      },
    };
  },
  mounted: function () {
    this.updateChartData();
  },

  watch: {
    basicAccelGyroData: function () {
      this.updateChartData();
    },
  },
  methods: {
    updateChartData: function () {
      this.series[0].data = this.basicAccelGyroData.map((x) => [
        new Date(x.time).getTime(),
        x.aX,
      ]);
      this.series[1].data = this.basicAccelGyroData.map((x) => [
        new Date(x.time).getTime(),
        x.aY,
      ]);
      this.series[2].data = this.basicAccelGyroData.map((x) => [
        new Date(x.time).getTime(),
        x.aZ,
      ]);

      this.$refs.accelChart.updateSeries(
        [
          {
            data: this.series[0].data,
          },
          {
            data: this.series[1].data,
          },
          {
            data: this.series[2].data,
          },
        ],
        false,
        true
      );
    },
  },
};
</script>
